module.exports = __webpack_public_path__ + "assets/img/4_147_big.504818c4.jpg";